import { Injectable, Inject, InjectionToken } from '@angular/core';
import { NgxsPlugin, getActionTypeFromInstance } from '@ngxs/store';
import { ClearModuleState } from '../action/state.action';
import { AppService } from '../service/app.service';
import { SubContentService } from '../service/sub-content.service';

export const CLEAR_STATE_PLUGIN_OPTIONS = new InjectionToken('CLEAR_STATE_PLUGIN_OPTIONS');

@Injectable()
export class ClearStatePlugin implements NgxsPlugin {

	constructor(
		@Inject(CLEAR_STATE_PLUGIN_OPTIONS) private options: any,
		private appService: AppService,
		private subContentService: SubContentService
	) { }

	/**
	 * Default handler for the meta-reducer
	 * 
	 * @param state 
	 * @param action 
	 * @param next 
	 * @returns 
	 */
	handle(state: any, action: any, next: any): any {

		const actionType = getActionTypeFromInstance(action);
		if (actionType === ClearModuleState.type) {
			const newState = this.appService.getModuleBaseState(action.currentModule);
			if (newState !== null) {
				this.subContentService.close();
				// get default state from appService
				console.warn(`Cleaning state from ${action.currentModule}`);
				// const newAppraisalDesktop = {appraisalDesktop: {inboxDesktop: {}, orderDesktop: {}}};
				state = {...state, ...newState};
			}
		}

		return next(state, action);
	}
}
